import React from "react";
import styles from "./Dialogue.module.scss";

import { messages } from "../Mixing.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";

export const Dialogue: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <div className={styles.panContainer}>
      <div key={1} className={styles.carouselItem}>
        <h3 className={styles.title}>{formatMessage(messages.dialogueSlideTitle)}</h3>
        <ui.Scrollbars>
          <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.dialogueSlideDescription) }}></p>
        </ui.Scrollbars>
      </div>
      ,
    </div>
  );
};
